var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 66,
    viewBox: "0 0 108 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2625 0.243164H0.763672V56.4257C0.763672 61.404 4.79941 65.4398 9.77775 65.4398H98.2354C103.214 65.4398 107.25 61.404 107.25 56.4257V7.6472H53.0836C51.8332 7.6472 50.6389 7.1277 49.7864 6.2129L45.5597 1.67746C44.7072 0.762666 43.513 0.243164 42.2625 0.243164Z",
    fill: "#96DAEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderFile);
export default __webpack_public_path__ + "static/media/folderFile.47e7b93d9badced5ed065361d3227ee5.svg";
export { ForwardRef as ReactComponent };